import React from 'react';
import '../../styles/components/AsperaCodeSnippet.scss';
import { language } from '../../services/LanguageService';
import { SubManager } from '../../classes/SubManager';
import { AsperaError } from '../../classes/AsperaError';
import { observableTimeout } from '../../helpers/starterHelpers';
import { getIcon } from '../Carbon';
/**
 * React Component
 *
 * The AsperaCodeSnippet provides a read-only text field that allows the value to be copied to clipboard.
 *
 * @example
 * ```javascript
 * <AsperaCodeSnippet type="single" value="Some text to display" helperText="Text underneath text box" />
 * ```
 */
export class AsperaCodeSnippet extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            showCopyNotification: false,
        };
        this.selectedText = React.createRef();
        this.subId = '';
        this.subManager = new SubManager();
        this.copyToClipboard = () => {
            var _a, _b;
            (_a = this.selectedText.current) === null || _a === void 0 ? void 0 : _a.focus();
            (_b = this.selectedText.current) === null || _b === void 0 ? void 0 : _b.select();
            // execCommand has been deprecated.  This will silence warnings
            // eslint-disable-next-line
            document.execCommand('copy');
            this.subManager.unsubscribe(this.subId);
            this.setState({ showCopyNotification: true });
            this.subId = this.subManager.setSubscription(observableTimeout(2000).subscribe({
                next: () => {
                    this.setState({ showCopyNotification: false });
                },
                error: error => {
                    new AsperaError('AsperaCodeSnippet: Unable to clear copy text notification', error);
                },
            }));
        };
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    get textField() {
        const { type, value, light } = this.props;
        switch (type) {
            case 'multi':
                return React.createElement("textarea", { readOnly: true, className: `cds--text-area text-area cds--snippet-container ${light ? 'light-mode' : ''}`, value: value, ref: this.selectedText });
            case 'single':
            default:
                return React.createElement("input", { readOnly: true, className: `cds--text-input text-input cds--snippet-container ${light ? 'light-mode' : ''}`, value: value, ref: this.selectedText });
        }
    }
    render() {
        const { helperText, monoFont, type, className, label, disabled } = this.props;
        const { showCopyNotification } = this.state;
        return (React.createElement("div", { className: `aspera-code-snippet font-${monoFont ? 'mono' : 'regular'} ${className ? className : ''}` },
            !!label && React.createElement("label", { className: "cds--label" }, label),
            React.createElement("div", { className: `cds--snippet cds--snippet--${type}` },
                React.createElement("div", { className: "text-field" }, this.textField),
                React.createElement("button", { type: "button", className: `cds--copy-btn cds--copy ${showCopyNotification ? 'cds--copy-btn--animating cds--copy-btn--fade-in' : ''}`, onClick: this.copyToClipboard, disabled: disabled },
                    getIcon('Copy', 32, { className: 'cds--snippet__icon' }),
                    React.createElement("span", { className: "cds--assistive-text cds--copy-btn__feedback" }, language.get('notifications.copied')))),
            helperText && React.createElement("div", { className: "cds--form__helper-text" }, helperText)));
    }
}
